import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ChevronLeft, X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface DeliveryZoneFilterValues {
  search: string;
  is_active: string;
}

interface Props {
  filters: DeliveryZoneFilterValues;
  onFilterChange: (key: keyof DeliveryZoneFilterValues, value: string) => void;
  onClearFilters: () => void;
}

export function DeliveryZoneFilterSidebar({ filters, onFilterChange, onClearFilters }: Props) {
  const [collapsed, setCollapsed] = useState(false);
  const hasActive = filters.search !== '' || filters.is_active !== '';

  if (collapsed) {
    return (
      <div className="w-3 flex flex-col items-center pt-2">
        <button onClick={() => setCollapsed(false)} className="text-muted-foreground hover:text-foreground">
          <ChevronLeft className="h-4 w-4 rotate-180" />
        </button>
      </div>
    );
  }

  return (
    <div className="w-56 shrink-0 space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">الفلاتر</span>
        <div className="flex items-center gap-1">
          {hasActive && (
            <Button variant="ghost" size="icon" className="h-6 w-6" onClick={onClearFilters} title="مسح">
              <X className="h-3 w-3" />
            </Button>
          )}
          <button onClick={() => setCollapsed(true)} className="text-muted-foreground hover:text-foreground">
            <ChevronLeft className="h-4 w-4" />
          </button>
        </div>
      </div>

      <div className="space-y-3">
        <div className="space-y-1.5">
          <Label className="text-xs">بحث</Label>
          <Input
            placeholder="اسم أو كود المنطقة..."
            value={filters.search}
            onChange={(e) => onFilterChange('search', e.target.value)}
            className="h-8 text-sm"
          />
        </div>

        <div className="space-y-1.5">
          <Label className="text-xs">الحالة</Label>
          <Select value={filters.is_active || 'all'} onValueChange={(v) => onFilterChange('is_active', v)}>
            <SelectTrigger className="h-8 text-sm">
              <SelectValue placeholder="الكل" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">الكل</SelectItem>
              <SelectItem value="true">نشط</SelectItem>
              <SelectItem value="false">غير نشط</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
